"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const text_input_1 = require("../text-input");
const merge_refs_1 = __importDefault(require("../merge-refs"));
// This purpose of this function is to make a string look like a partially
// filled or complete phone number. It inserts parentheses, spaces, and dashes
// depending on how long the string is.
// "12" => "12"
// "123" => "(123) "
// "12345" => "(123) 45"
// "123456" => "(123) 456-"
// "1234567" => "(123) 456-7"
// "1234567890" => "(123) 456-7890"
function formatPhoneNumber(value) {
    if (value.length < 3)
        return value;
    else if (value.length >= 3 && value.length < 6) {
        return `(${value.slice(0, 3)}) ${value.slice(3)}`;
    }
    else {
        return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }
}
function getNumbers(inputValue) {
    return inputValue.replaceAll(/[^\d]/g, "").slice(0, 10);
}
function PhoneInput({ value, onChange, inputRef, ...rest }) {
    const localInputRef = (0, react_1.useRef)(null);
    const previousInputValue = (0, react_1.useRef)("");
    (0, react_1.useEffect)(() => {
        if (previousInputValue.current !== localInputRef.current?.value) {
            previousInputValue.current = localInputRef.current?.value || "";
        }
    });
    const formattedValue = formatPhoneNumber(value);
    const handlePhoneChange = event => {
        const inputValue = event.target.value;
        let onlyNumbers = getNumbers(inputValue);
        const previousNumbers = getNumbers(previousInputValue.current);
        // If they tried to make this shorter by backspacing over a non-digit, then
        // erase a number for them like they intended
        const isOneShorter = inputValue.length === previousInputValue.current.length - 1;
        const isSameNumbers = onlyNumbers === previousNumbers;
        if (isOneShorter && isSameNumbers) {
            onlyNumbers = onlyNumbers.slice(0, onlyNumbers.length - 1);
        }
        if (onlyNumbers !== value)
            onChange(onlyNumbers, event);
    };
    return ((0, jsx_runtime_1.jsx)(text_input_1.TextInput, { ...rest, inputRef: (0, merge_refs_1.default)(inputRef, localInputRef), value: formattedValue, onChange: handlePhoneChange }));
}
exports.PhoneInput = PhoneInput;
